import { useEffect } from "react";

export const useScrollToTop = (dependencies: any[] = []) => {
  useEffect(() => {
    typeof window !== "undefined" && window.scrollTo(0, 0);
  }, dependencies);
};
